import * as types from '../types/textEditors'
const defaultState = []

const textEditors = ( state = defaultState, action ) => {
  const { type, payload } = action
  switch( type ) {

  case types.ADD_TEXT_EDITOR:
    const editor = state.find( e => e.id === payload.id )
    if( !editor ) {
      state.push( payload )
    }
    return state
  
  case types.UPDATE_TEXT_EDITOR:
    const newState = state.map( e => {
      if( +e.id === +payload.id ){
        e.editorState = payload.editorState
      }
      return e
    } )
    return [ ...newState ]
    
  default:
    return state
  }
}

const activeTextEditor = ( state = null, action ) => {
  const { type, payload } = action
  switch( type ) {

  case types.SET_ACTIVE_EDITOR:
    if( !payload ) {
      return null
    }
    const editor = payload.textEditors.find( i => +i.id === +payload.id )
    return editor || state
  
  default:
    return state
  }
}

export {
  textEditors,
  activeTextEditor
}


// WEBPACK FOOTER //
// ./src/store/reducers/textEditors.js